export default {
    visits: 'الزيارات',
    'visits-done': 'الزيارات المنجزة',
    'month-visits': 'زيارات شهرية (حتى تاريخ اليوم)',
    'leave-requests': 'طلبات الإجازة',
    'administrative-day': 'يوم إداري',
    'modification-requests': 'طلبات التعديل',
    'customer-addition-requests': 'طلبات إضافة الزبائن',
    'customer-deletion-requests': 'طلبات حذف',
    'number-of-visits-for-the-last-month-according-to-classification': 'عدد الزيارات خلال الشهر الماضي حسب التصنيف',
    'number-of-employees-per-role': 'عدد الموظفين لكل دور',
    'number-of-visits-for-the-last-week-depending-on-the-number-of-customers': 'عدد الزيارات خلال الاسبوع الماضي حسب عدد الزبائن',
    'welcome-new-members': 'أهلا بالأفراد الجدد',
    'outgoing-and-remaining-materials': 'المواد الصادرة والمتبقية',
    'the-ten-most-widely-used-materials': 'المواد العشرة الأكثر استخدامًا',
    'top3-commonly-used-materials': 'أفضل 3 مواد مستخدمة بشكل شائع',
    'least3-commonly-used-materials': 'أقل 3 مواد مستخدمة',
    'the-ten-stagnant-materials': 'المواد العشرة الراكدة',
    'visit-count': 'عدد الزيارات',
    'entity-count': 'عدد الجهات',
    'deliver-amount': 'الكمية المسلمة',
    'remaining': 'المتبقي',
    'count-employee': 'عدد الموظفين',
    'quantity-received': 'الكمية المستلمة',
    'quantity-delivered': 'الكمية المسلمة',
    'visits-number' : 'عدد الزيارات',
    'entities-number': 'عدد الجهات',
    'yesterday': 'زيارات الأمس'
}